export default __webpack_public_path__ + "static/media/suitenupcias_9.9cf12481.jpg";